var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('TheAppbar',{attrs:{"title":_vm.$t('title')}}),_c('v-main',[_c('v-container',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('desc'))}}),_c('TheForm',{attrs:{"page-type":"contact"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }